// Copyright ©️ 2026 eVolve MEP, LLC

import { useMemo } from 'react';

import { PRODUCT_IDS } from 'constants/globalConstants';
import { useEvolveGetWithLocalStorage } from 'hooks/useEvolveGetWithLocalStorage';

/**
 * Used to get (cached) conduit types and sizes for fabrication.
 *
 * @remarks Only pulls types and sizes if the user has a Fabrication License.
 * */
export const useConduits = () => {
  const { data: conduitTypes, loading: loadingTypes } = useEvolveGetWithLocalStorage('shop/fabrication/conduitTypes', {
    requireLicense: PRODUCT_IDS.FABRICATION_LICENSE,
  });
  const { data: conduitSizes, loading: loadingSizes } = useEvolveGetWithLocalStorage('shop/fabrication/conduitSizes', {
    requireLicense: PRODUCT_IDS.FABRICATION_LICENSE,
  });

  return useMemo(
    () => ({
      conduitTypes,
      conduitSizes,
      loading: loadingTypes || loadingSizes,
    }),
    [conduitTypes, conduitSizes, loadingTypes, loadingSizes],
  );
};
